import React from 'react';
import * as S from './styles';
import { SkeletonLoading } from '@/main/components/shared/styles';

interface ITypographyLabelValueProps {
  label: string | undefined;
  value: any | undefined;
  isLoading?: boolean;
}

function TypographyLabelValue({
  label,
  value,
  isLoading = false
}: ITypographyLabelValueProps) {
  if (isLoading)
    return (
      <S.Container>
        <S.Label>
          <SkeletonLoading />
        </S.Label>
        <S.Value>
          : <SkeletonLoading />
        </S.Value>
      </S.Container>
    );

  return (
    <S.Container>
      <S.Label>{label}: </S.Label>
      <S.Value>{value}</S.Value>
    </S.Container>
  );
}

export default TypographyLabelValue;
